import React from 'react';
import { Link } from 'react-router-dom';
import AdSlot from './AdSlotComponent';
import Card from './ui/Card';

/**
 * Hub de conteúdo editorial: ajuda o Google a ver o site como publicação + ferramenta,
 * não só aplicativo (critério “conteúdo de baixo valor”).
 */
function RecursosPage() {
    return (
        <Card className="p-6 max-w-3xl mx-auto text-left" data-editorial-content="true">
            <h1 className="text-2xl font-bold mb-4">Recursos sobre Planning Poker e agilidade</h1>
            <p className="mb-4 text-slate-300 leading-relaxed">
                Além da ferramenta gratuita para votação em tempo real, o Pleini Pouquer reúne textos
                originais em português sobre estimativas, refinamento de backlog, Scrum e boas práticas
                para Product Owners, Scrum Masters e times de desenvolvimento. O objetivo é oferecer
                leitura útil antes e depois da sessão de Planning Poker — seja para treinar novos
                membros, alinhar vocabulário (story points, complexidade versus esforço) ou preparar
                reuniões de planejamento com mais clareza.
            </p>
            <p className="mb-6 text-slate-300 leading-relaxed">
                Use os links abaixo para aprofundar temas específicos. O conteúdo é atualizado
                periodicamente com base em feedback de usuários e nas diretrizes do Manifesto Ágil
                e do Scrum Guide.
            </p>

            <ul className="space-y-4 mb-8">
                <li className="border border-white/10 rounded-lg p-4 bg-slate-900/30">
                    <Link to="/guia" className="text-lg font-semibold text-sky-400 hover:underline">
                        Guia completo: Planning Poker para equipes ágeis
                    </Link>
                    <p className="text-slate-400 text-sm mt-1">
                        O que é, passo a passo, sequências, remoto e erros comuns.
                    </p>
                </li>
                <li className="border border-white/10 rounded-lg p-4 bg-slate-900/30">
                    <Link
                        to="/artigo-refinamento-backlog"
                        className="text-lg font-semibold text-sky-400 hover:underline"
                    >
                        Refinamento de backlog e estimativas no Scrum
                    </Link>
                    <p className="text-slate-400 text-sm mt-1">
                        Como o refinamento se conecta ao Planning Poker, riscos e facilitação.
                    </p>
                </li>
                <li className="border border-white/10 rounded-lg p-4 bg-slate-900/30">
                    <Link to="/faq" className="text-lg font-semibold text-sky-400 hover:underline">
                        Perguntas frequentes (FAQ)
                    </Link>
                    <p className="text-slate-400 text-sm mt-1">
                        Dúvidas rápidas sobre contas, votação e privacidade.
                    </p>
                </li>
                <li className="border border-white/10 rounded-lg p-4 bg-slate-900/30">
                    <Link to="/sobre" className="text-lg font-semibold text-sky-400 hover:underline">
                        Sobre o projeto Pleini Pouquer
                    </Link>
                    <p className="text-slate-400 text-sm mt-1">
                        Objetivos, versão e contato.
                    </p>
                </li>
            </ul>

            <p className="text-slate-500 text-sm mb-6">
                Sugestões de novos temas podem ser enviadas pelo e-mail indicado no rodapé do site.
            </p>

            <AdSlot adSlot="7348901130475950" format="auto" />
        </Card>
    );
}

export default RecursosPage;
